import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
var TimeSelector = function (_a) {
    var label = _a.label, onTimeChange = _a.onTimeChange, initialValue = _a.initialValue, _b = _a.lockMinutes, lockMinutes = _b === void 0 ? false : _b;
    var _c = useState(""), hour = _c[0], setHour = _c[1];
    var _d = useState(""), minute = _d[0], setMinute = _d[1];
    var _e = useState(""), period = _e[0], setPeriod = _e[1];
    var _f = useState(""), convertedTime = _f[0], setConvertedTime = _f[1];
    useEffect(function () {
        if (initialValue) {
            var _a = initialValue.split(":"), initHour = _a[0], initMinute = _a[1];
            var hr = parseInt(initHour, 10);
            var min = initMinute;
            var per = hr >= 12 ? "PM" : "AM";
            var stdHour = hr % 12 === 0 ? 12 : hr % 12;
            setHour(stdHour.toString());
            setMinute(min);
            setPeriod(per);
        }
        else {
            setHour("");
            setMinute(lockMinutes ? "00" : "");
            setPeriod("");
        }
    }, [initialValue]);
    var hours = Array.from({ length: 12 }, function (_, i) { return i + 1; });
    var convertTo24Hour = function () {
        // console.log('time', hour, minute ,period)
        if (!hour || !minute || !period) {
            return;
        }
        var hour24 = parseInt(hour);
        if (period === "AM") {
            if (hour24 === 12) {
                hour24 = 0;
            }
        }
        else {
            if (hour24 !== 12) {
                hour24 += 12;
            }
        }
        var formattedTime = "".concat(hour24.toString().padStart(2, "0"), ":").concat(minute);
        setConvertedTime(formattedTime);
        console.log("Converted Time:", formattedTime);
        onTimeChange(formattedTime);
    };
    useEffect(function () {
        convertTo24Hour();
    }, [hour, minute, period]);
    return (_jsxs("div", { className: "w-full mx-auto p-0", children: [_jsx("label", { className: "mb-3 text-[15px] font-[500]", children: label || "Select Time" }), _jsxs("div", { className: "flex gap-3 mb-2", children: [_jsxs("select", { value: hour, onChange: function (e) { return setHour(e.target.value); }, className: "flex-1 px-3 py-2 border rounded-md dock-select-ui", children: [_jsx("option", { value: "", className: "text-[#76808B]", children: "Hour" }), hours.map(function (h) { return (_jsx("option", { value: h, children: h }, h)); })] }), _jsxs("select", { value: !lockMinutes ? minute : "00", onChange: function (e) { return setMinute(e.target.value); }, className: "flex-1 px-3 py-2 border rounded-md dock-select-ui", children: [!lockMinutes && _jsx("option", { value: "", className: "text-[#76808B]", children: "Min" }), _jsx("option", { value: "00", children: "00" }), !lockMinutes && _jsx("option", { value: "30", children: "30" })] }), _jsxs("select", { value: period, onChange: function (e) { return setPeriod(e.target.value); }, className: "flex-1 px-3 py-2 border rounded-md dock-select-ui", children: [_jsx("option", { value: "", className: "text-[#76808B]", children: "AM/PM" }), _jsx("option", { value: "AM", children: "AM" }), _jsx("option", { value: "PM", children: "PM" })] })] })] }));
};
export default TimeSelector;
